export const verifica_se_tem_pelo_menos_um_carater_especial = (palavra: string | undefined) => {
  var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (palavra !== undefined) {


    if (format.test(palavra)) {
      return true;
    } else {
      return false;
    }
  }else{
    return false
  }
}